import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';
import { RegraLinha } from '../../regra-linha';

@Component({
  selector: 'app-importar-xml-regras-step',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatIconModule, MatSlideToggleModule, AlertCardComponent],
  templateUrl: './importar-xml-regras-step.component.html',
  styleUrls: ['./importar-xml-regras-step.component.css'],
})
export class ImportarXmlRegrasStepComponent {
  @Input() regras: RegraLinha[] = [];
  @Input() consideraApenasDescricao = false;

  @Output() moverRegra = new EventEmitter<{ indice: number; direcao: -1 | 1 }>();
  @Output() restaurarPadrao = new EventEmitter<void>();
  @Output() consideraApenasDescricaoChange = new EventEmitter<boolean>();

  onMoverRegra(indice: number, direcao: -1 | 1): void {
    this.moverRegra.emit({ indice, direcao });
  }

  onRestaurarPadrao(): void {
    this.restaurarPadrao.emit();
  }

  onToggleDescricaoChange(valor: boolean): void {
    this.consideraApenasDescricao = valor;
    this.consideraApenasDescricaoChange.emit(valor);
  }
}
